module.exports = __webpack_public_path__ + "img/heaven_and_earth_box1.1b2bbeb4.png";